import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import * as React from 'react';

import {type Sort} from '../../../util/queryTypes';
import {
  type ResetColorRun,
  useResetColors,
  useResetColorsInfo,
} from './useResetColors';

export function getShouldHideRandomizeColors(
  numRows: number,
  modifiedSort: boolean,
  hasActiveFilter: boolean,
  hasActiveSearch: boolean,
  hasActiveGroupKeys: boolean
) {
  return (
    numRows < 2 || // if only one row
    (!modifiedSort &&
      !hasActiveFilter &&
      !hasActiveSearch &&
      !hasActiveGroupKeys)
  );
}

export function getShouldHideResetColors(
  hasCustomRunColors: boolean | undefined
) {
  return !hasCustomRunColors;
}

export function useShouldHideResetRunColorsSection(
  sort: Sort,
  rows: ResetColorRun[],
  isColumnMenuOpen: boolean
) {
  const {
    modifiedSort,
    hasActiveFilter,
    hasActiveSearch,
    hasActiveGroupKeys,
    hasCustomRunColors,
  } = useResetColorsInfo(sort, rows, !isColumnMenuOpen);

  const hideRandomizeColors = getShouldHideRandomizeColors(
    rows.length,
    modifiedSort,
    hasActiveFilter,
    hasActiveSearch,
    hasActiveGroupKeys
  );
  const hideResetColors = getShouldHideResetColors(hasCustomRunColors);
  return hideRandomizeColors && hideResetColors;
}

export const ResetRunColors = ({
  sort,
  rows,
}: {
  sort: Sort;
  rows: ResetColorRun[];
}) => {
  const {
    modifiedSort,
    hasActiveFilter,
    hasActiveSearch,
    hasActiveGroupKeys,
    hasCustomRunColors,
    randomizeColors,
    resetColors,
  } = useResetColors(sort, rows);
  const hideRandomizeColors = getShouldHideRandomizeColors(
    rows.length,
    modifiedSort,
    hasActiveFilter,
    hasActiveSearch,
    hasActiveGroupKeys
  );
  const hideResetColors = getShouldHideResetColors(hasCustomRunColors);
  return (
    <>
      {!hideRandomizeColors && (
        <DropdownMenu.Item onSelect={randomizeColors}>
          <Icon name="randomize" />
          Randomize colors
        </DropdownMenu.Item>
      )}
      {!hideResetColors && (
        <DropdownMenu.Item onSelect={resetColors}>
          <Icon name="randomize-reset-reload" />
          Reset colors
        </DropdownMenu.Item>
      )}
    </>
  );
};
